(function () {
  const IFRAME_SOURCE = 'leaderboard';
  const HOST_SOURCE = 'leaderboard-host';

  function buildEmbedSrc(dataSrc) {
    let embedUrl;
    try {
      embedUrl = new URL(dataSrc, window.location.href);
    } catch {
      return null;
    }

    embedUrl.searchParams.set('embed', 'true');

    const pageParams = new URLSearchParams(window.location.search);
    const circuit = pageParams.get('circuit');
    const combine = pageParams.get('combine');
    if (circuit) embedUrl.searchParams.set('circuit', circuit);
    if (combine) embedUrl.searchParams.set('combine', combine);

    return embedUrl;
  }

  function getHeaderHeight() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    const parsed = parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 84;
  }

  /** Visible iframe band in iframe-document coordinates (reference embed protocol). */
  function getIframeViewportBand(iframeEl) {
    const rect = iframeEl.getBoundingClientRect();
    const headerHeight = getHeaderHeight();
    const top = Math.max(0, -rect.top);
    const height =
      Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, headerHeight);

    return {
      top,
      height: Math.max(0, height),
    };
  }

  function initRoot(root) {
    const iframe = root.querySelector('iframe[data-leaderboard-src]');
    if (!iframe || iframe.dataset.leaderboardReady === 'true') return;

    const embedUrl = buildEmbedSrc(iframe.getAttribute('data-leaderboard-src'));
    if (!embedUrl) return;

    const minHeight = parseInt(iframe.dataset.minHeight, 10) || 400;
    const origin = embedUrl.origin;
    let modalOpen = false;

    function sendViewport() {
      if (!iframe.contentWindow) return;

      const band = getIframeViewportBand(iframe);
      iframe.contentWindow.postMessage(
        {
          source: HOST_SOURCE,
          type: 'viewport',
          top: band.top,
          height: band.height,
        },
        origin
      );
    }

    function setModalOpen(open) {
      modalOpen = open;
      sendViewport();
    }

    window.addEventListener('message', (event) => {
      if (event.origin !== origin || event.source !== iframe.contentWindow) return;

      const data = event.data;
      if (!data || data.source !== IFRAME_SOURCE) return;

      if (data.type === 'height' && typeof data.height === 'number') {
        iframe.style.height = `${Math.max(Math.ceil(data.height), minHeight)}px`;
        if (!modalOpen) {
          sendViewport();
        }
        return;
      }

      if (data.type === 'scrollTo' && typeof data.top === 'number') {
        if (modalOpen) {
          return;
        }
        const rect = iframe.getBoundingClientRect();
        const headerHeight = getHeaderHeight();
        const targetY = window.scrollY + rect.top + data.top - headerHeight;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
        sendViewport();
        return;
      }

      if (data.type === 'modal') {
        setModalOpen(!!data.open);
      }
    });

    iframe.addEventListener('load', () => {
      sendViewport();
    });

    window.addEventListener('scroll', () => {
      if (modalOpen) return;
      sendViewport();
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (modalOpen) return;
      sendViewport();
    }, { passive: true });

    iframe.dataset.leaderboardReady = 'true';
    iframe.src = embedUrl.toString();
  }

  function init() {
    document.querySelectorAll('[data-leaderboard-embed]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-leaderboard-embed]');
    if (root) initRoot(root);
  });
})();
